import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "content-item__main" }
const _hoisted_3 = { class: "content-item__title" }
const _hoisted_4 = { class: "content-item__length" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
    title: (_ctx.isBlocked || !_ctx.isReleased) ? 'conteúdo indisponível' : _ctx.title,
    class: [
      'content-item',
      {blocked: _ctx.isBlocked | !_ctx.isReleased},
      {active: _ctx.isActive},
      {youtube: _ctx.type === _ctx.ContentType.YOUTUBE},
      {scorm: _ctx.type === _ctx.ContentType.SCORM},
      {exercise: _ctx.type === _ctx.ContentType.EXERCISE},
      {pdf: _ctx.type === _ctx.ContentType.PDF},
      {mp3: _ctx.type === _ctx.ContentType.MP3},
    ]
  }), [
    _renderSlot(_ctx.$slots, "circular-progress"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.length), 1),
        (!_ctx.isReleased)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(['content-item__flag', { upcoming: !_ctx.isReleased }])
            }, "EM BREVE", 2))
          : _createCommentVNode("", true),
        (_ctx.isNew)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(['content-item__flag', { new: _ctx.isReleased }])
            }, "NOVO", 2))
          : _createCommentVNode("", true),
        (_ctx.isInCorrection)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass(['content-item__flag', { inCorrection: _ctx.isInCorrection }])
            }, "EM CORREÇÃO", 2))
          : _createCommentVNode("", true)
      ])
    ])
  ], 16, _hoisted_1))
}